import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {DataCollectionStatus} from "../model/server.model";
import {SecurityUtils} from "../security.utils";
import {catchError} from "rxjs/operators";
import {HttpClientUtils} from "../../utils/http-client.utils";
import {HealthStatus} from "../model/new-application.model";
import {Injectable} from "@angular/core";
import {Organization} from "../organization.service";

@Injectable()
export class WorkstationConfigurationService {

	constructor(private httpClient: HttpClient) {}

	private backendUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/workstation-configuration`;

	getWorkstationConfiguration(tenantId: string, workstationId: string): Observable<WorkstationConfiguration> {
		return this.httpClient.get<WorkstationConfiguration>(`${this.backendUrl(tenantId)}/${workstationId}`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		}).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
	}

	getWorkstationConfigurationUsers(tenantId: string, workstationId: string): Observable<WorkstationUser[]> {
		return this.httpClient.get<WorkstationUser[]>(`${this.backendUrl(tenantId)}/${workstationId}/users`, {
			headers: SecurityUtils.getAuthHttpHeaders()
		}).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
	}

	getTenantWorkstationConfiguration(tenantId: string): Observable<WorkstationConfiguration[]> {
		return this.httpClient.get<WorkstationConfiguration[]>(`${this.backendUrl(tenantId)}`, {
			headers: SecurityUtils.getAuthHttpHeaders(),
		}).pipe(catchError(error => HttpClientUtils.handleError(error, [])));
	}
}

export interface WorkstationConfiguration {
	id: string
	structureId: string
	teamId: string
	hostname: string
	userRealName: string | null
	health: HealthStatus
	bootUpTime: number | null
	uptime: number
	laptop: boolean
	manufacturer: string | null
	workstationModel: string | null
	serialNumber: string | null
	privateIp: string | null
	externalIp: string | null
	load: number
	lastCollectDate: string
	collectStatus: DataCollectionStatus
	osModel: string
	osVersion: string
	cpuUsed: number
	ramUsed: number
	storageUsed: number | null
	batteryHealth: number | null
	storageLoad: number | null
	isFirewallEnabled: boolean | null,
	isEncryptionEnabled: boolean | null,
	isEdrEnabled: boolean | null
}

export interface WorkstationUser {
	userId: string,
	userRealName: string | null,
	structure: Organization | null,
	team: Organization | null
}

export interface WorkstationExportCsv {
	hostname: string
	userRealName: string
	health: string
	load: string,
	lastCollectDate: string
	model: string
	cpuUsed: string
	ramUsed: string
	batteryHealth: string
	storageLoad: string
}
